module.exports = new __parcel__URL__("bossfight_status_in_progress.ea3ce292.png").toString();